
import { Card } from '@/components/ui/card'
import type { License } from '@/lib/types'

interface LicensesStatsProps {
  licenses: License[]
}

export function LicensesStats({ licenses }: LicensesStatsProps) {
  const activeCount = licenses.filter(l => !l.isRevoked && new Date(l.expiresAt) > new Date()).length
  const totalTenants = licenses.reduce((acc, l) => acc + (l.tenants?.length || 0), 0)
  const revokedCount = licenses.filter(l => l.isRevoked).length

  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Active Licenses</span>
        <span className="text-2xl font-bold mt-2">{activeCount}</span>
      </Card>
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Total Tenants</span>
        <span className="text-2xl font-bold mt-2">{totalTenants}</span>
      </Card>
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Revoked</span>
        <span className="text-2xl font-bold mt-2 text-red-600">{revokedCount}</span>
      </Card>
    </div>
  )
}
